import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10ea159b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "air-dialog-content" }
const _hoisted_2 = { class: "dialog-top" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leave-title" }, "工作辛苦了!", -1))
const _hoisted_5 = { class: "leave-popup-body" }
const _hoisted_6 = {
  key: 1,
  class: "text-status"
}
const _hoisted_7 = {
  key: 2,
  class: "text-status grey"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "隐藏", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createBlock(_component_van_dialog, {
    show: _ctx.isShowLeaveDailog,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowLeaveDailog) = $event)),
    class: "dialog-width",
    "show-confirm-button": false,
    "show-cancel-button": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.leaveDetail.img)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-yellow",
                src: _ctx.parseImgUrl('page-officehome', _ctx.leaveDetail.img),
                alt: ""
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaveDetail.textObj, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "body-item",
              key: idx
            }, [
              (item.status === 'ok')
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    name: "passed",
                    style: {"color":"#07c160","margin-right":"8px"}
                  }))
                : _createCommentVNode("", true),
              (item.status === 'go')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                : _createCommentVNode("", true),
              (item.status === 'grey')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(item.text), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "dialog-btns",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDailog && _ctx.closeDailog(...args)))
        }, _hoisted_9)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}